import {api} from './Api';

/**
 * Chamadas do totem de atendimento (rotas /v1/totem da API).
 * Não usa token: todo request leva o código da empresa e a senha do totem,
 * que fica guardada apenas no navegador do totem (localStorage).
 */

const SENHA_KEY = 'totem_netcomet_senha';

export type TotemCliente = {
	id: number;
	nome: string;
	documento: string;
}

export type TotemContrato = {
	id_contrato: number;
	numero_contrato: string;
	data: string;
	plano: string;
	status: string;
	endereco: string | null;
	endereco_numero: string | null;
	bairro: string | null;
	cidade: string | null;
	faturas_em_aberto: number;
	faturas_vencidas: number;
	proximo_vencimento: string | null;
}

export type TotemFatura = {
	id: number;
	numero_documento: string;
	valor_documento: number;
	valor_total: number;
	data_vencimento: string;
	plano: string | null;
	baixado: number;
	numero_contrato: string;
	cobranca_entrada_confirmada: number;
	id_status: number;
	id_cobranca_registro_lancamento: boolean | null;
	status: 'aberto' | 'vencido' | 'pago';
	valor_juros: number;
	valor_multa: number;
	boleto: number | null;
}

export function getSenhaTotem(): string {
	try {
		return localStorage.getItem(SENHA_KEY) || '';
	} catch (e) {
		return '';
	}
}

export function setSenhaTotem(senha: string) {
	try {
		localStorage.setItem(SENHA_KEY, senha);
	} catch (e) {
	}
}

export function limparSenhaTotem() {
	try {
		localStorage.removeItem(SENHA_KEY);
	} catch (e) {
	}
}

function corpo(extra: Record<string, unknown> = {}) {
	return {
		codigo: process.env.REACT_APP_SUPERGER_API_CODIGO,
		senha: getSenhaTotem(),
		...extra,
	};
}

export function mensagemErro(error: any, padrao = 'Não foi possível concluir a operação'): string {
	const data = error?.response?.data;
	if (data && typeof data.message === 'string') {
		return data.message;
	}
	if (!error?.response) {
		return 'Sem comunicação com o servidor';
	}
	return padrao;
}

export const totemApi = {
	liberar(senha: string) {
		return api.post('v1/totem/liberar', {
			codigo: process.env.REACT_APP_SUPERGER_API_CODIGO,
			senha,
		});
	},

	cliente(documento: string): Promise<{ cliente: TotemCliente; contratos: TotemContrato[] }> {
		return api.post('v1/totem/cliente', corpo({documento})).then(r => r.data);
	},

	faturas(documento: string, id_contrato: number): Promise<TotemFatura[]> {
		return api.post('v1/totem/faturas', corpo({documento, id_contrato})).then(r => r.data);
	},

	boletoPdf(documento: string, id: number): Promise<Blob> {
		return api.post('v1/totem/boleto', corpo({documento, id}), {responseType: 'blob'})
			.then(r => new Blob([r.data], {type: 'application/pdf'}));
	},

	linhaDigitavel(documento: string, id: number): Promise<string> {
		return api.post('v1/totem/linha-digitavel', corpo({documento, id})).then(r => r.data.dados);
	},

	qrcode(documento: string, id: number): Promise<string> {
		return api.post('v1/totem/qrcode', corpo({documento, id})).then(r => r.data.dados);
	},
};
